module.exports = __webpack_public_path__ + "static/img/random.5139909e.svg";